<div class="container">
    <h3>Prediction Results</h3>
    <div class="selection-row">
        <app-bc-pr-selection (gradeSelected)="onGradeSelected($event)"></app-bc-pr-selection>
        <button
            type="button"
            class="blue-button methods-btn"
            (click)="resultTable.openMethodsPanel()"
            title="View the test method for each property">
            <span class="material-icons-outlined btn-icon" aria-hidden="true">science</span>
            <span>Test Methods</span>
        </button>
    </div>
    <app-bc-pr-result-table #resultTable
        [blend1Details]="blend1Predictions"
        [blend2Details]="blend2Predictions"
        [j300_1Details]="j300_1Details" 
        [j300_2Details]="j300_2Details">
    </app-bc-pr-result-table>
</div>